/* eslint-disable jira/filename-case */
declare global {
	interface Window {
		/**
		 * disables stability render in development mode
		 */
		disableStabilityCheck(): void;

		/**
		 * runs (or enables) stability render in dev mode
		 * See {@link import('@jira/platform__test-utils-stability-control/src/runtime-injection.tsx').activateStabilityRuntime} for details
		 */
		runStabilityCheck(): void;
	}
}

if (
	// disable this feature for production mode
	process.env.NODE_ENV !== 'production'
) {
	// save to prevent mutations
	// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
	const ss = sessionStorage;
	const ACTIVATION_KEY = 'dev:stabilityCheck';

	// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
	if (sessionStorage.getItem(ACTIVATION_KEY)) {
		const {
			activateStabilityRuntime,
			// oxlint-disable-next-line typescript/no-require-imports
		} = require('@jira/platform__test-utils-stability-control/src/runtime-injection.tsx');

		// activate stability
		activateStabilityRuntime();

		// oxlint-disable-next-line no-console
		console.warn('⚠️ STABILITY CHECK IS ACTIVE ⚠️. To deactivate enter `disableStabilityCheck();`');
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.disableStabilityCheck = () => {
			ss.removeItem(ACTIVATION_KEY);
			// oxlint-disable-next-line no-console
			console.log('Stability check disabled. Reloading...');
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.reload();
		};
	} else {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.runStabilityCheck = () => {
			// oxlint-disable-next-line no-console
			console.log('Stability check is not yet active. Reloading...');
			ss.setItem(ACTIVATION_KEY, 'true');
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.reload();
		};
	}
}

// required for global augmentation to work
export {};
